import styled from "styled-components";

export const ObjectBody = styled.div`
  padding-bottom: var(--outerMargin);
  border-bottom: var(--border);
  margin-bottom: var(--gap);
  & > div {
    margin-bottom: var(--gap);
  }
  & .description {
    margin: 0;
    font-size: 150%;
  }
`;
